import React, { useState } from 'react';
import { Button, Image, Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import ChildIc from '../../../assets/images/visit-child-popup.svg';
import IcCopy from '../../../assets/icon/ic-copy.svg';
import IcCopyWhite from '../../../assets/icon/ic-copy-white.svg';

const TreehouseCreatedModal = ({ isOpen, setIsOpen, treehouseCode }) => {
  const [show, setShow] = useState(isOpen);
  const [copiedClass, setCopiedClass] = useState("");
  const history = useHistory();

  const closeModal = () => {
    setShow(false);
    setIsOpen(false);
    history.replace({
      state: {
        from: ""
      }
    })
  }

  async function copyTextToClipboard() {
    setCopiedClass(copiedClass === "copied" ? "" : "copied");
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(`${treehouseCode}`);
    } else {
      return document.execCommand('copy', true, `${treehouseCode}`);
    }
  }

  return (
    <Modal show={show} onHide={closeModal} className="account-varification add-challenges-modal partner-room-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          <div className='batch-ic'>
            <Image src={ChildIc} alt="" />
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h3 className="mt-4 mb-50">
          Your tribe has been created!
        </h3>
        <p className="mt-4 mb-50">
          You can now invite guardians to connect their kids account to your tribe.
        </p>
        <div className="share-link">
          <div className={"link-txt " + copiedClass}>
            {copiedClass === "copied" ? <span>Link copied to clipboard</span> : <span>{treehouseCode}</span>}
            <span className="copy-icon" onClick={copyTextToClipboard}>
              {copiedClass === "copied" ?
                <img src={IcCopyWhite} alt="copy" />
                :
                <img src={IcCopy} alt="copy" />}
            </span>
          </div>
        </div>
        <Button className='rounded-pill gred-btn' onClick={closeModal}>Finish</Button>
      </Modal.Body>
    </Modal>
  )
}

export default TreehouseCreatedModal;